import Container, { Service } from 'typedi'
import GtrStorage from './storage.service'

@Service()
export default class SecurityContext {
  public context () {
    return Container.get(GtrStorage).getItem('user_session')
  }

  public expiresAt () {
    const context = Container.get(GtrStorage).getItem('user_session')
    if (context) {
      return JSON.parse(context).expires_at || null
    }
    return null
  }

  public token (course_uuid?: string) {
    return Container.get(GtrStorage).getItem(`${course_uuid}_registration_access_token`)
  }
}
